import React, {useEffect} from 'react';
import {Container} from '../../shared/components/container';
import {ServicesContent} from '../../shared/components/content';
import {GradientView} from '../../shared/components/gradientView';
import {LoadableContent} from '../../shared/components/loadableContent';
import {NewsCarousel} from '../../shared/components/newsCarousel';
import Screen from '../../shared/components/screen';
import {CustomScrollView} from '../../shared/components/scrollView';
import {Text} from '../../shared/components/text';
import {hexToRgbA} from '../../shared/pipes';
import {useTheme} from '../../shared/theme';
import {DeviceSize, useDeviceSize} from '../../shared/theme/helpers';
import {Notifications} from './common/notification';
import {Welcome} from './common/welcome';
import {Props} from './model';
import useStyles from './styles';
import {Platform} from 'react-native';

export default (props: Props) => {
  const deviceSize = useDeviceSize();
  const theme_ = useTheme();
  const styles = useStyles();

  const titleStyle = deviceSize === DeviceSize.desktop ? styles.titleContainerDesktop : styles.titleContainerMobile;

  useEffect(() => {
    const requestNotificationsPermission = async () => {
      if (Platform.OS !== 'android') return;
      if (Number(Platform.Version) < 33) return;

      try {
        const PermissionsAndroid = require('react-native').PermissionsAndroid;
        if (!PermissionsAndroid) return;
        await PermissionsAndroid.request(PermissionsAndroid.PERMISSIONS.POST_NOTIFICATIONS);
      } catch (err) {
        console.warn('Notification permission request failed:', err);
      }
    };

    // Delay permission request to avoid conflicts during initialization
    const timer = setTimeout(requestNotificationsPermission, 1000);
    return () => clearTimeout(timer);
  }, []);

  return (
    <Screen fullWidth>
      <CustomScrollView style={styles.con} contentInsetAdjustmentBehavior='automatic'>
        <LoadableContent loading={!props.profile}>
          <Container>
            <Welcome name={props.profile?.displayName || ''} />
            <Notifications notifications={props.notifications} hideBottomLineWhenAllShown />
          </Container>
          <GradientView
            style={styles.gradientContainer}
            gradient={{angle: 90, colors: theme_.services.bgGradient.map((color) => hexToRgbA(color, 0.9))}}>
            <Container>
              <Text testID='card-possibility-label-id' aria-level='1' accessibilityRole='header' style={titleStyle}>
                Возможности карты
              </Text>
              <ServicesContent />
            </Container>
          </GradientView>
          <Container style={styles.newsContainer}>
            <Text
              testID='last-carousel-news-label-id'
              aria-level='1'
              accessibilityRole='header'
              style={[titleStyle, {marginBottom: 6}]}>
              Последние новости
            </Text>
            <NewsCarousel news={props.latestNews} />
          </Container>
        </LoadableContent>
      </CustomScrollView>
    </Screen>
  );
};
